/**
 * [退押金审核弹窗]
 * @Author: Fu Xiaochun
 * @Email:  f2e.xiaochun@gmail.com
 */
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './AuditModal.module.scss';
import http from '@/assets/api/http';
import { Modal, message, Radio, Input, Select } from 'antd';
import {  regFenToYuan } from '@/util/money';

const { TextArea } = Input;

function AuditModal(props){

    const [auditStatus, setAuditStatus] = useState('COMPLETE');
    const [remark, setRemark] = useState('');

    const onOk = ()=>{
        if(remark == ''){
            message.warn('请输入审核意见！');
            return false;
        }
        let params = {
            id: props.item.groupId,
            status: auditStatus,
            auditReason: remark
        };

        http('/?cmd=com.xqxc.api.pig.mis.biz.account.RiderDepositMisService.auditDepositRefund', params, 'POST').then((res) => {
            message.success('操作成功！');
            props.onOk();
        }).catch((e) => {
            message.error(e.message);
        });
    };

    const onCancel = ()=>{
        props.onClose();
    };

    const onAuditStatusChange = (e)=>{
        let val = e.target.value;
        setAuditStatus(val);
    };

    const onRemarkChange = (e)=>{
        let val = e.target.value || '';
        val = val.trim();
        setRemark(val);
    };

    const maskName = (value)=>{
        const name = value ? value.toString() : '';
        const len = name.length;
        if(len == 0){
            return value;
        }else if (len > 0 && len <= 2) {
            return name.substr(0, 1) + '*';
        } else {
            return name.substr(0, 1) + '*' + name.substr(len - 1);
        }
    };

    const maskTel = (tel)=>{
        return tel.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    };

    return <Modal title="退押金审核" open={true} onOk={onOk} onCancel={onCancel}>
        <div className={styles.container}>
            <div className={styles.tips}>审核内容：押金账户余额、是否有未处理的赔付</div>
            <div className={styles.item}>
                <div className={styles.label}>骑手信息</div>
                <div className={styles.val}>{maskName(props.item.riderName || '-')}（{maskTel(props.item.riderTel)}）</div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>申请退回</div>
                <div className={styles.val}>¥{regFenToYuan(props.item.refundFee)}</div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}><span>*</span>审核结果</div>
                <div className={styles.val}>
                    <Radio.Group onChange={onAuditStatusChange} value={auditStatus}>
                        <Radio value='COMPLETE'>审核通过</Radio>
                        <Radio value='NOT_PASSED'>审核失败</Radio>
                    </Radio.Group>
                </div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}><span>*</span>审核意见</div>
                <div className={styles.val}>
                    <TextArea rows={4} value={remark} onChange={onRemarkChange} placeholder="请输入审核意见" />
                </div>
            </div>
        </div>
      </Modal>;
}

AuditModal.propTypes = {
    item: PropTypes.object,
    onOk: PropTypes.func,
    onClose: PropTypes.func
};

export default AuditModal;